(function() {
  var currentSelectedBrand = 'all';

  function filterErrorCodes() {
    var searchInput = document.getElementById('errorCodeInput');
    var input = searchInput ? searchInput.value.toLowerCase().trim() : '';
    var clearBtn = document.getElementById('clearSearchBtn');
    if (clearBtn) {
      clearBtn.style.display = input ? 'inline-flex' : 'none';
    }
    applyErrorFilters();
  }

  function clearErrorSearch() {
    var searchInput = document.getElementById('errorCodeInput');
    if (searchInput) {
      searchInput.value = '';
      searchInput.focus();
    }
    var clearBtn = document.getElementById('clearSearchBtn');
    if (clearBtn) clearBtn.style.display = 'none';
    applyErrorFilters();
  }

  function filterErrorBrand(brand, btn) {
    currentSelectedBrand = brand;
    var chips = document.querySelectorAll('.err-chip');
    chips.forEach(function(c) { c.classList.remove('active'); });
    if (btn) btn.classList.add('active');
    applyErrorFilters();
  }

  function resetAllErrorFilters() {
    var searchInput = document.getElementById('errorCodeInput');
    if (searchInput) searchInput.value = '';
    var clearBtn = document.getElementById('clearSearchBtn');
    if (clearBtn) clearBtn.style.display = 'none';
    
    currentSelectedBrand = 'all';
    var chips = document.querySelectorAll('.err-chip');
    chips.forEach(function(c, idx) {
      if (idx === 0) c.classList.add('active');
      else c.classList.remove('active');
    });
    applyErrorFilters();
  }

  function applyErrorFilters() {
    var searchInput = document.getElementById('errorCodeInput');
    var input = searchInput ? searchInput.value.toLowerCase().trim() : '';
    var brand = currentSelectedBrand;

    var cards = document.querySelectorAll('.error-card');
    var visibleCount = 0;

    cards.forEach(function(card) {
      var cardBrand = card.getAttribute('data-brand') || '';
      var matchesBrand = (brand === 'all') || 
                         (cardBrand === brand) || 
                         (brand === 'Segway-Ninebot' && (cardBrand === 'Xiaomi' || cardBrand === 'Segway-Ninebot'));
      
      var cardText = card.textContent.toLowerCase();
      var matchesSearch = !input || (cardText.indexOf(input) > -1);

      if (matchesBrand && matchesSearch) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    // Update index cards
    var indexCards = document.querySelectorAll('.error-index-card');
    indexCards.forEach(function(card) {
      var cardBrand = card.getAttribute('data-brand') || '';
      var matchesBrand = (brand === 'all') || 
                         (cardBrand === brand) || 
                         (brand === 'Segway-Ninebot' && (cardBrand === 'Xiaomi' || cardBrand === 'Segway-Ninebot'));

      if (!matchesBrand) {
        card.style.display = 'none';
        return;
      }

      if (!input) {
        card.style.display = '';
        var rows = card.querySelectorAll('.index-row');
        rows.forEach(function(r) { r.parentElement.style.display = ''; });
        return;
      }

      var hasVisibleRow = false;
      var rows = card.querySelectorAll('.index-row');
      rows.forEach(function(row) {
        var rowText = row.textContent.toLowerCase();
        if (rowText.indexOf(input) > -1) {
          row.parentElement.style.display = '';
          hasVisibleRow = true;
        } else {
          row.parentElement.style.display = 'none';
        }
      });

      if (hasVisibleRow) {
        card.style.display = '';
        card.open = true; // Auto-expand matching index cards on search
      } else {
        card.style.display = 'none';
      }
    });

    // Status bar & Reset button
    var statusEl = document.getElementById('errorStatusCount');
    var resetBtn = document.getElementById('resetFiltersBtn');
    var noResultsEl = document.getElementById('errorNoResults');

    if (statusEl) {
      if (input || brand !== 'all') {
        var brandLabel = brand === 'all' ? '' : ' (' + brand + ')';
        statusEl.innerHTML = 'Showing <strong>' + visibleCount + '</strong> of 75 verified diagnostic codes' + brandLabel;
        if (resetBtn) resetBtn.style.display = 'inline-flex';
      } else {
        statusEl.innerHTML = 'Showing all <strong>75</strong> verified diagnostic codes';
        if (resetBtn) resetBtn.style.display = 'none';
      }
    }

    if (noResultsEl) {
      noResultsEl.style.display = (visibleCount === 0) ? 'block' : 'none';
    }
  }

  function toggleAllMasterIndex() {
    var cards = document.querySelectorAll('.error-index-card');
    var btn = document.getElementById('indexToggleAllBtn');
    if (!cards.length) return;
    
    var anyOpen = false;
    cards.forEach(function(card) {
      if (card.open && card.style.display !== 'none') anyOpen = true;
    });

    cards.forEach(function(card) {
      card.open = !anyOpen;
    });

    if (btn) {
      btn.textContent = anyOpen ? 'Expand All' : 'Collapse All';
    }
  }

  function scrollToErrorSearch() {
    var searchEl = document.getElementById('errorCodeInput');
    if (searchEl) {
      searchEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      searchEl.focus();
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  window.addEventListener('scroll', function() {
    var btn = document.getElementById('errorScrollTopBtn');
    if (!btn) return;
    if (window.scrollY > 450) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
  }, { passive: true });

  // Expose to window for inline onclick handlers
  window.filterErrorCodes = filterErrorCodes;
  window.clearErrorSearch = clearErrorSearch;
  window.filterErrorBrand = filterErrorBrand;
  window.resetAllErrorFilters = resetAllErrorFilters;
  window.toggleAllMasterIndex = toggleAllMasterIndex;
  window.scrollToErrorSearch = scrollToErrorSearch;
})();
